import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { Logo, Button, Field, Input } from "@/lib/ui";
import { useAuth } from "@/context/Auth";

export default function ChangePassword() {
  const nav = useNavigate();
  const { user, refresh } = useAuth();
  const [current, setCurrent] = useState(user?.phone || "");
  const [next, setNext] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/seller/change-password", { current_password: current, new_password: next });
      toast.success("Password changed. The temporary mobile-number password is now invalid.");
      await refresh();
      nav(user?.profile_complete ? "/seller/app" : "/seller/onboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 fade-up">
        <Logo />
        <h1 className="mt-6 font-head text-2xl font-extrabold text-slate-900">Set your password</h1>
        <p className="mt-1 text-sm text-slate-500">For security, change your temporary password before continuing.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <Field label="Current / Temporary Password" required>
            <Input data-testid="pw-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} />
          </Field>
          <Field label="New Password" required hint="At least 6 characters, and not your mobile number.">
            <Input data-testid="pw-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} />
          </Field>
          <Button data-testid="pw-submit" type="submit" disabled={loading} className="w-full">
            {loading ? "Saving…" : "Change Password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
